export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-05_00.e0f7fc01.jpg";